module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_07@3x-0ce2fefb3e4e3df889658a72aca51d95.webp";